/* eslint-disable react/jsx-no-literals */
import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';

import { getManagedPrinterProfileByCode } from './api';

/** The QR points at a mutable profile, not a frozen calibration snapshot. */
export function PrinterProfileQrPage() {
  const { shortCode = '' } = useParams();
  const profile = useQuery({ queryKey: ['labels', 'printer-profile-code', shortCode], queryFn: () => getManagedPrinterProfileByCode(shortCode), enabled: Boolean(shortCode) });
  if (profile.isLoading) return <p className="boot">Загрузка профиля принтера…</p>;
  if (!profile.data) return <main className="panel"><h2>Профиль принтера не найден</h2><Link to="/print/printers">К принтерам</Link></main>;
  const item = profile.data;
  return <main className="panel"><h2>{item.name}</h2><p>{item.model} · {item.connection_kind}</p><p>{item.status === 'ready' && item.is_enabled ? 'Готов к печати' : 'Профиль сохранён, но сейчас не предлагается для новой печати.'}</p><p>Привязано шаблонов: {item.template_count}. Последнее изменение: {new Date(item.updated_at).toLocaleString()}.</p><Link to="/print/printers">Открыть настройки принтеров</Link></main>;
}
